import {
  ChargingSession,
  StopChargingSessionResponse,
} from 'types/generatedSchemaTypes';

export const stopChargingSessionResponse: StopChargingSessionResponse = {
  chargingSessionId: '844a498c-5efc-4bb9-8422-7b4ee65c8f72',
  startTime: new Date('2022-03-18T07:55:40.918Z'),
  endTime: new Date('2022-03-18T07:56:15.187Z'),
  status: 'STOP_IN_QUEUE',
  token: 'LIMNPA5SKWWEDS5HRF37',
  licensePlate: 'ABC123',
  parkingZoneUid: 'FI-CORCAV2',
  chargingLocationId: 'EVB-P1639086',
  evseId: '1729281',
  customerUid: '59b7ac53c9e77c001143a61e',
  stationId: 'b4a463a2-54c3-4611-a529-983f825cdf75',
  transactionId: null,
  stopInQueue: new Date('2022-03-18T07:56:15.187Z'),
  paymentRetries: null,
  errorMessage: null,
  stopToQueueRetries: 1,
  priceInCents: 200,
  energyInWatts: 0,
  energyMeterStart: null,
  energyMeterEnd: null,
  cdrId: null,
  customerEmail: 'FirstNameMock.LastNameMock@mailinator.com',
  cardId: '4f426f82-321e-48da-aa67-655552731bc2',
  countryCode: 'FI',
  retryPaymentAutomatically: true,
  provider: 'EMABLER',
  createdBy: {
    clientId: 'aimo-one-backend',
    name: null,
    email: null,
    userId: null,
  },
  created: new Date('2022-03-18T07:55:31.791Z'),
  updatedBy: {
    clientId: 'aimo-one-backend',
    name: null,
    email: null,
    userId: null,
  },
  updated: new Date('2022-03-18T07:56:15.189Z'),
};

const oneHourAgo = () => {
  const now = new Date();
  now.setHours(now.getHours() - 1);
  return now;
};

export const chargingSession: { readActiveChargingSession: ChargingSession } = {
  readActiveChargingSession: {
    chargingSessionId: 'e61f192b-c7ee-4018-bf0b-e8405d409d18',
    startTime: oneHourAgo(),
    endTime: null,
    status: 'IN_PROGRESS',
    token: 'KDTKBLU7Y0DNPC6SQ5ZL',
    licensePlate: 'ABC123',
    parkingZoneUid: '00d777ae-4d5c-4777-b891-d1c75fa35a90',
    chargingLocationId: 'EVB-P1639086',
    evseId: '1729281',
    customerUid: '59b7ac53c9e77c001143a61e',
    stationId: 'b4a463a2-54c3-4611-a529-983f825cdf75',
    transactionId: null,
    stopInQueue: null,
    paymentRetries: 5,
    errorMessage: null,
    stopToQueueRetries: null,
    priceInCents: 215,
    energyInWatts: 20000,
    energyMeterStart: 0,
    energyMeterEnd: 20000,
    cdrId: null,
    customerEmail: 'FirstNameMock.LastNameMock@mailinator.com',
    cardId: 'c66ff184-76f9-4c80-b25b-98ca4621a557',
    countryCode: 'FI',
    retryPaymentAutomatically: true,
    provider: 'EMABLER',
    createdBy: {
      clientId: 'aimo-one-backend',
      name: null,
      email: null,
      userId: null,
    },
    created: new Date('2022-04-07T12:51:07.100Z'),
    updatedBy: {
      clientId: 'microservice-backend',
      name: 'Session-service scheduler',
      email: null,
      userId: null,
    },
    updated: new Date('2022-04-07T13:18:10.153Z'),
  },
};

export const ongoingChargingSession: {
  readOngoingChargingSessionV3: ChargingSession;
} = {
  readOngoingChargingSessionV3: {
    chargingSessionId: 'e61f192b-c7ee-4018-bf0b-e8405d409d18',
    startTime: oneHourAgo(),
    endTime: null,
    status: 'IN_PROGRESS',
    token: 'KDTKBLU7Y0DNPC6SQ5ZL',
    licensePlate: 'ABC123',
    parkingZoneUid: 'FI-G7RCBR3',
    chargingLocationId: 'EVB-P1639086',
    evseId: '1729281',
    customerUid: '59b7ac53c9e77c001143a61e',
    stationId: 'b4a463a2-54c3-4611-a529-983f825cdf75',
    transactionId: null,
    stopInQueue: null,
    paymentRetries: 5,
    errorMessage: null,
    stopToQueueRetries: null,
    priceInCents: 215,
    energyInWatts: 20000,
    energyMeterStart: 0,
    energyMeterEnd: 20000,
    cdrId: null,
    customerEmail: 'FirstNameMock.LastNameMock@mailinator.com',
    cardId: 'c66ff184-76f9-4c80-b25b-98ca4621a557',
    countryCode: 'FI',
    retryPaymentAutomatically: true,
    provider: 'EMABLER',
    createdBy: {
      clientId: 'aimo-one-backend',
      name: null,
      email: null,
      userId: null,
    },
    created: new Date('2022-04-07T12:51:07.100Z'),
    updatedBy: {
      clientId: 'microservice-backend',
      name: 'Session-service scheduler',
      email: null,
      userId: null,
    },
    updated: new Date('2022-04-07T13:18:10.153Z'),
  },
};
